function isPromise(promise) {
    return promise !== 'null' &&
        typeof promise === 'object' &&
        typeof promise.then === 'function' &&
        typeof promise.catch === 'function';
}
export function check(fetch, Headers, Request, Response) {
    if (typeof fetch !== 'function') {
        throw TypeError(`'fetch' was not a 'function': ${typeof fetch}`);
    }
    else if (typeof Headers !== 'function') {
        throw TypeError(`'Headers' was not a constructor: ${typeof Headers}`);
    }
    else if (typeof Request !== 'function') {
        throw TypeError(`'Request' was not a constructor: ${typeof Request}`);
    }
    else if (typeof Response !== 'function') {
        throw TypeError(`'Response' was not a constructor: ${typeof Response}`);
    }
    const headers = new Headers({ a: '1' });
    if (typeof headers.get !== 'function' || headers.get('a') !== '1') {
        throw new TypeError(`'Headers' implementation was incorrect`);
    }
    const response = new Response('abc');
    if (typeof response.text !== 'function' || !isPromise(response.text())) {
        throw new TypeError(`'Response' implementation was incorrect`);
    }
    const request = new Request('abc');
    if (typeof request.text !== 'function' || !isPromise(request.text())) {
        throw new TypeError(`'Request' implementation was incorrect`);
    }
    return [fetch, Headers, Request, Response];
}
export default check;
//# sourceMappingURL=check.js.map